import React, { useState, useEffect, useRef } from 'react';
//import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import './index.css';

import { ReactComponent as Logo } from 'common/icons/branding/logo.svg';
import { ReactComponent as BurgerIcon } from './icons/burger.svg';
import { ReactComponent as SearchIcon } from 'common/icons/search.svg';
// support.svg, notifications.svg, localization.svg, user.svg, vertical_dots.svg
import { ReactComponent as SupportIcon } from './icons/support.svg';
import { ReactComponent as NotificationsIcon } from './icons/notifications.svg';
import { ReactComponent as LocalizationIcon } from './icons/localization.svg';
import { ReactComponent as DotGridIcon } from './icons/dot_grid.svg';
import { ReactComponent as UserIcon } from './icons/user.svg';
import { ReactComponent as VerticalDotsIcon } from './icons/vertical_dots.svg';
import { ReactComponent as SupportChatIcon } from './icons/SupportChat.svg';
import { ReactComponent as SupportFAQIcon } from './icons/SupportFAQ.svg';
import { ReactComponent as SupportEmailIcon } from './icons/SupportEmail.svg';
import { ReactComponent as SupportPhoneIcon } from './icons/SupportPhone.svg';
import { ReactComponent as SupportGeoIcon } from './icons/SupportGeo.svg';
import { ReactComponent as SupportWorkHoursIcon } from './icons/SupportWorkHours.svg';
import { ReactComponent as UserChangeIcon } from './icons/userChange.svg';
import { ReactComponent as PolygonIcon } from './icons/Polygon.svg';

import { ReactComponent as HeartIcon } from './icons/heart.svg';
import { ReactComponent as BookmarkIcon } from './icons/bookmark.svg';
import { ReactComponent as CartIcon } from './icons/shopping-cart.svg';
import { ReactComponent as GlobeIcon } from './icons/globe_dollar.svg';
import { Switch, Tooltip } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from 'common/context/AuthContext';
import Button from '../Button/index';
import { Transition } from 'react-transition-group';


export default function Header({ isLightTheme, setThemePicked }: { isLightTheme: boolean; setThemePicked: React.Dispatch<React.SetStateAction<boolean>> }): JSX.Element {
  const theme = useTheme();
  const { token, logout } = useAuth();
  // console.log(token);
  const navigate = useNavigate();

  

  const [userAuthOpen, setUserAuthOpen] = useState(false);
  useEffect(() => {
    if (token !== '' && token !== undefined && token !== null) {
      setUserAuthOpen(true);
    } else {
      setUserAuthOpen(false);
    }
  }, [token]);

  const [dropdownsOpen, setDropdownsOpen] = useState({
    contacts: false,
    notifications: false,
    languages: false,
    appsAstin: false,
    profile: false,
    other: false,
  });
  const openDropdownsMenu = (name) => {
    setDropdownsOpen((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };
  const iconsRef = {
    contacts: useRef(null),
    notifications: useRef(null),
    languages: useRef(null),
    appsAstin: useRef(null),
    profile: useRef(null),
    other: useRef(null),
  };
  const dropdownsRef = {
    contacts: useRef(null),
    notifications: useRef(null),
    languages: useRef(null),
    appsAstin: useRef(null),
    profile: useRef(null),
    other: useRef(null),
  };
  const handleClickOutside = (event) => {
    for (const name in dropdownsOpen) {
      if (dropdownsOpen[name]) {
        if (!dropdownsRef[name].current.contains(event.target) && !iconsRef[name].current.contains(event.target)) {
          setDropdownsOpen((prev) => ({
            ...prev,
            [name]: !prev[name],
          }));
        }
      }
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [dropdownsOpen]);
  // if any of the menus are open show dimming
  const dimming = Object.values(dropdownsOpen).some((item) => item === true);
  const duration = 300;

  const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
  };

  const transitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  };

  const logoutHandler = () => {
    logout();
    // close all dropdowns
    for (const name in dropdownsOpen) {
      if (dropdownsOpen[name]) {
        setDropdownsOpen((prev) => ({
          ...prev,
          [name]: !prev[name],
        }));
      }
    }
    navigate('/login');
  };

  return (
    <>
      <Transition in={dimming} timeout={duration} unmountOnExit>
        {(state) => (
          <div className='header-dimming' style={{ ...defaultStyle, ...transitionStyles[state] }}></div>
        )}
      </Transition>
      <div className='header-wrapper' style={{ borderBottom: `1px solid ${theme.colors.primaryTextColor === '#040D2D' ? theme.colors.gray : 'transparent'}`, backgroundColor: theme.colors.secondaryBackgroundColor }}>
        <div className='header-left'>
          <Tooltip title='Меню' placement='bottom'>
            <div className='header-item-wrapper fill'>
              <BurgerIcon className='svg-black svg-fill' />
            </div>
          </Tooltip>
          <NavLink to={'/'}>
            <Logo className='svg-none svg-primary-fill' />
          </NavLink>
          <div className='header-search-wrapper'>
            <Tooltip title='Пошук по ASTIN' placement='bottom'>
              <div className='header-item-wrapper stroke'>
                <SearchIcon className='svg-black' stroke={theme.colors.black} />
              </div>
            </Tooltip>
            <input style={{ backgroundColor: 'transparent', color: theme.colors.primaryTextColor }} className='header-search' placeholder='Пошук...' />
          </div>
        </div>
        <div className='header-right'>

          <div className='navContainer'>
            <div>
              <Tooltip title='Допомога' placement='bottom'>
                <div className={dropdownsOpen.contacts ? 'header-item-wrapper fill fill-dropdownOpened' : 'header-item-wrapper fill'}>
                  <SupportIcon ref={iconsRef.contacts} className='svg-black svg-fill' onClick={() => openDropdownsMenu('contacts')} />
                </div>
              </Tooltip>
            </div>
            {dropdownsOpen.contacts && <div ref={dropdownsRef.contacts} className='navItem_dropdown contactTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle' />
              <div className="dropdownBody" style={{ backgroundColor: theme.colors.secondaryColor }}>
                <a href="#" className='contactNavItem dropdownBody_Item'>
                  <SupportChatIcon className='svg-black svg-fill' />
                  <span>Чат служби підтримки</span>
                </a>
                <a href="#" className='contactNavItem dropdownBody_Item'>
                  <SupportFAQIcon className='svg-black svg-fill' />
                  <span>FAQ</span>
                </a>
                <a href="#" className='contactNavItem dropdownBody_Item'>
                  <SupportEmailIcon className='svg-black svg-fill' />
                  <span>E-mail</span>
                </a>
                <a href="#" className='contactNavItem dropdownBody_Item'>
                  <SupportPhoneIcon className='svg-black svg-fill' />
                  <span>Phone</span>
                </a>
                <a href="#" className='contactNavItem dropdownBody_Item'>
                  <SupportGeoIcon className='svg-black svg-fill' />
                  <span>Geo</span>
                </a>
                <a href="#" className='contactNavItem dropdownBody_Item'>
                  <SupportWorkHoursIcon className='svg-black svg-fill' />
                  <span>Work hours</span>
                </a>
              </div>
            </div>}
          </div>

          <div className='navContainer'>
            <div>
              <Tooltip title='Сповіщення' placement='bottom'>
                <div className={dropdownsOpen.notifications ? 'header-item-wrapper stroke stroke-dropdownOpened' : 'header-item-wrapper stroke'}>
                  <NotificationsIcon ref={iconsRef.notifications} className='svg-black' onClick={() => openDropdownsMenu('notifications')} />
                </div>
              </Tooltip>
            </div>
            {dropdownsOpen.notifications && <div ref={dropdownsRef.notifications} className='navItem_dropdown notificationTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle' />
              <div className="dropdownBody" style={{ backgroundColor: theme.colors.secondaryColor }}>
                <span className='notificationsNavItem dropdownBody_Item'>У вас ще немає сповіщень</span>
              </div>
            </div>}
          </div>

          <div className='navContainer'>
            <div>
              <Tooltip title='Локалізація' placement='bottom'>
                <div className='header-localization-wrapper' ref={iconsRef.languages} onClick={() => openDropdownsMenu('languages')}>
                  <div className={dropdownsOpen.languages ? 'header-item-wrapper fill fill-dropdownOpened' : 'header-item-wrapper fill'}>
                    <LocalizationIcon className='svg-black svg-fill' />
                  </div>
                  <span className={dropdownsOpen.languages ? 'header-localization-text color-dropdownOpened' : 'header-localization-text'}>UA</span>
                </div>
              </Tooltip>
            </div>
            {dropdownsOpen.languages && <div ref={dropdownsRef.languages} className='navItem_dropdown languageTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle' />
              <div className='dropdownBody' style={{ backgroundColor: theme.colors.secondaryColor }}>
                <a href="#" className='languageNavItem dropdownBody_Item'>EN</a>
                <a href="#" className='languageNavItem dropdownBody_Item'>UA</a>
              </div>
            </div>}
          </div>

          <div className='navContainer'>
            <div>
              <Tooltip title='Додатки ASTIN' placement='bottom'>
                <div className={dropdownsOpen.appsAstin ? 'header-item-wrapper stroke stroke-dropdownOpened' : 'header-item-wrapper stroke'}>
                  <DotGridIcon ref={iconsRef.appsAstin} className='svg-black' onClick={() => openDropdownsMenu('appsAstin')} />
                </div>
              </Tooltip>
            </div>
            {dropdownsOpen.appsAstin && <div ref={dropdownsRef.appsAstin} className='navItem_dropdown appsAstinTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle appsAstindropdownTriangle' />
              <div className='dropdownBody appsAstinContainer u-fancy-scrollbar' style={{ backgroundColor: theme.colors.secondaryColor }}>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>S</div>
                  <span>Search</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>M</div>
                  <span>My account</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>w</div>
                  <span>Workspace</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>P</div>
                  <span>Planner</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>C</div>
                  <span>Calendar</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>M</div>
                  <span>Messenger</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>S</div>
                  <span>Support</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>M</div>
                  <span>Mail</span>
                </div>
                <div className='appsAstinNavItem dropdownBody_Item'>
                  <div>U</div>
                  <span>University</span>
                </div>
              </div>
            </div>}
          </div>

          <div className='navContainer'>
            <div>
              <Tooltip title='Профіль' placement='bottom'>
                <div className={dropdownsOpen.profile ? 'header-item-wrapper fill fill-dropdownOpened' : 'header-item-wrapper fill'}>
                  <UserIcon ref={iconsRef.profile} className='svg-black svg-fill' onClick={() => openDropdownsMenu('profile')} />
                </div>
              </Tooltip>
            </div>
            {!userAuthOpen && dropdownsOpen.profile && <div ref={dropdownsRef.profile} className='navItem_dropdown profileTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle' />
              <div className="dropdownBody" style={{ backgroundColor: theme.colors.secondaryColor }}>
                <Button onClick={() => window.location.href = '/login'} className='profileNavItem dropdownBody_Item' label="SIGN IN"></Button>
              </div>
            </div>}

            {userAuthOpen && dropdownsOpen.profile && <div ref={dropdownsRef.profile} className='navItem_dropdown authProfileTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle authProfiledropdownTriangle' />
              <div className="dropdownBody authUserDdB" style={{ backgroundColor: theme.colors.secondaryColor }}>
                <div>
                  <div className='authUserAvatar'>
                    <UserIcon className='svg-black svg-fill' />
                    {/* <img src="https://kartinki.pibig.info/uploads/posts/2023-04/1681895316_kartinki-pibig-info-p-kartinki-dlya-profilya-arti-instagram-1.jpg"></img> */}
                    <UserChangeIcon className="userChangeAvatar" />
                  </div>
                  <div className='userName_Email'>
                    <span>User Name</span>
                    <span>e-mail</span>
                  </div>
                  <Button className='authUserNavButton dropdownBody_Item' label="Settings"></Button>
                  <Button className='authUserNavButton dropdownBody_Item' label="My Account"></Button>
                  <hr />
                  <div className='addAccountContainer'>
                    <span>+</span>
                    <span>Add account</span>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <Button onClick={logoutHandler} className='authUserNavButton dropdownBody_Item' label="Log Out"></Button>
                  <div className='smallBottomText'>
                    <a href='#Privacy Policy' >Privacy Policy</a>
                    <a href='#Terms of Use' >Terms of Use</a>
                  </div>
                </div>
              </div>
            </div>}
          </div>

          <div className='navContainer'>
            <div>
              <Tooltip title='Додатково' placement='bottom'>
                <div className={dropdownsOpen.other ? 'header-item-wrapper stroke stroke-dropdownOpened' : 'header-item-wrapper stroke'}>
                  <VerticalDotsIcon ref={iconsRef.other} className='svg-black' onClick={() => openDropdownsMenu('other')} />
                </div>
              </Tooltip>
            </div>
            {dropdownsOpen.other && <div ref={dropdownsRef.other} className='navItem_dropdown otherTransform'>
              <PolygonIcon fill={theme.colors.backgroundColor} className='dropdownTriangle' />
              <div className="dropdownBody verticalDotsDropdownBody" style={{ backgroundColor: theme.colors.secondaryColor }}>
                <div className='verticalDotsIcon'>
                  <HeartIcon className='svg-black' />
                </div>
                <div className='verticalDotsIcon'>
                  <BookmarkIcon className='svg-black' />
                </div>
                <div className='verticalDotsIcon'>
                  <CartIcon className='svg-black' />
                </div>
                <div className='verticalDotsIcon'>
                  <GlobeIcon className='svg-black' />
                </div>
                <div className='header-switch-wrapper'>
                  <Switch size='small' sx={{
                    '&:not(.Mui-checked) .MuiSwitch-track': {
                      backgroundColor: '#5678FF',
                    },
                  }} checked={isLightTheme} onChange={() => { setThemePicked(!isLightTheme); }} />
                </div>
              </div>
            </div>}
          </div>

        </div>
      </div>
    </>
  );
}
